import { DialogBox } from '@medly-components/core';
import styled from 'styled-components';

export const TopRightVector = styled.img`
    position: absolute;
    left: 0;
    top: 0;
    @media (max-width: 768px) {
        display: none;
    }
`;
export const TopRightVectorMobile = styled.img`
    position: absolute;
    left: 0;
    top: 0;
    display: none;
    @media (max-width: 768px) {
        display: block;
    }
`;

export const MedlyDialogBox = styled(DialogBox)`
    #medly-dialog-box-popup {
        width: calc(100% - 4.8rem);
        max-width: 42.8rem;
        height: auto;
        padding: 5.6rem 2.5rem 2.4rem;
        text-align: center;
        @media (max-width: 768px) {
            padding: 2.4rem;
            max-width: 35.5rem;
            height: auto;
        }
    }
    #medly-dialog-box-content {
        color: ${({ theme }) => theme.colors.grey[700]};
        font-weight: 400;
        font-size: 1.6rem;
        flex: initial;
        line-height: 2.2rem;
        br {
            @media (max-width: 768px) {
                display: none;
            }
        }
    }
    #medly-dialog-box-close-button {
        border: 1px solid ${({ theme }) => theme.colors.grey[300]};
        font-size: 1.6rem;
        padding: 0.7rem;
        & path {
            fill: ${({ theme }) => theme.colors.darkBlue};
        }
    }
    img {
        top: 0;
    }
    h4 {
        text-align: center;
        font-weight: 400;
        font-size: 2.2rem;
        line-height: 3rem;
        @media (max-width: 768px) {
            font-size: 2rem;
            line-height: 2.8rem;
            padding: 0 2rem;
        }
    }
    #medly-dialog-box-actions {
        margin-top: 4rem;
        @media (max-width: 768px) {
            margin-top: 2.6rem;
        }
    }
    button {
        width: 100%;
        max-width: 100%;
        background: ${({ theme }) => theme.colors.coral[500]};
        font-size: 1.6rem;
        font-style: normal;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.black};
    }
    button:not(:disabled):not(:hover) {
        width: 100%;
        max-width: 100%;
        background: ${({ theme }) => theme.colors.coral[500]};
        font-size: 1.6rem;
        font-style: normal;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.black};
    }
    button:not(:disabled):not(:active):hover {
        width: 100%;
        max-width: 100%;
        background: ${({ theme }) => theme.colors.coral[500]};
        font-size: 1.6rem;
        font-style: normal;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.black};
    }
`;

export const DialogBoxHeader = styled(DialogBox.Header)``;

export const DialogBoxContent = styled(DialogBox.Content)``;
